<ng-container *ngIf="cart$ | async as cart">
  <cx-order-summary [cart]="cart"></cx-order-summary>
</ng-container>
